import React from "react";
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    NumberField,
    DateField,
    Show,
    SimpleShowLayout,
    RichTextField,
} from "react-admin";

export const UserActionLogList = () => (
    <List
        perPage={25}
        sort={{ field: "created_at", order: "DESC" }}
        title="Действия пользователей"
    >
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <TextField source="action_group" label="Группа" />
            <TextField source="action_type" label="Действие" />
            <TextField source="endpoint" label="Endpoint" />
            <TextField source="http_method" label="Метод" />
            <NumberField source="status_code" label="HTTP" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="duration_ms" label="Время, мс" />
        </Datagrid>
    </List>
);

export const UserActionLogShow = () => (
    <Show title="Действие пользователя">
        <SimpleShowLayout>
            <DateField source="created_at" label="Дата" showTime />
            <TextField source="username_snapshot" label="Пользователь" />
            <TextField source="action_group" label="Группа" />
            <TextField source="action_type" label="Действие" />
            <TextField source="endpoint" label="Endpoint" />
            <TextField source="http_method" label="Метод" />
            <NumberField source="status_code" label="HTTP статус" />
            <BooleanField source="success" label="Успешно" />
            <NumberField source="duration_ms" label="Время, мс" />
            <TextField source="ip_address" label="IP" />
            <RichTextField source="user_agent" label="User-Agent" />
            <TextField source="error_message_short" label="Ошибка" />
            <NumberField source="user_id" label="User ID" />
        </SimpleShowLayout>
    </Show>
);